import type { Locale } from '@/i18n/i18n';
import { isProxyOwnedLegalPath, localePath, stripLocale } from '@/i18n/paths';

// The www article's translations already exist in the frontend blog corpus.
// Navigate to them directly: its slug redirect does not retain query parameters.
const articlePaths: Record<Locale, string> = {
  pl: '/blog/ewidencja-przychodow-ryczalt-jak-prowadzic-2026',
  en: '/en/blog/revenue-records-lump-sum-guide-2026',
  uk: '/uk/blog/oblik-dokhodiv-yedynyi-podatok-2026',
};

/** Localized blog pages belong to the Next proxy, beyond the landing router. */
export function localeNavigation(pathname: string, locale: Locale) {
  const suffixIndex = pathname.search(/[?#]/);
  const path = suffixIndex < 0 ? pathname : pathname.slice(0, suffixIndex);
  const suffix = suffixIndex < 0 ? '' : pathname.slice(suffixIndex);
  const destination = Object.values(articlePaths).includes(path)
    ? articlePaths[locale] + suffix
    : localePath(pathname, locale);
  return {
    path: destination,
    fullPage:
      isProxyOwnedLegalPath(destination) ||
      (locale !== 'pl' && stripLocale(path).startsWith('/blog/')),
  };
}
